import React from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';

export const DataSetFileConfigurationComponent = ({
  fileName,
  setFileName,
  fileNameLabel,
}: {
  fileName: string;
  setFileName: Setter<string>;
  fileNameLabel: string;
}) => {
  return (
    <SimpleInput
      label={fileNameLabel}
      value={fileName}
      onChange={setFileName}
    />
  );
};
